import axios from 'axios';
import { BASE_URL } from 'constants/index';

export const BM_CREATE = async (e) => {
  const res = await axios.post(BASE_URL + `/bm/instance/create`, e);
  return res.data;
};
